import { ListGroup } from "react-bootstrap";
import NewSecurities from "./NewSecurities";
import RebalanceOpportunities from "./RebalanceOpportunities";
import TradeProposalSummary from "./TradeProposalSummary";
import UnassignedAccounts from "./UnassignedAccounts";
import UnassignedCashSettings from "./UnassignedCashSettings";
import UnassignedFeeStructuresModels from "./UnassignedFeeStructuresModels";
import UnknownTaxClassification from "./UnknownTaxClassification";
import UnmappedSecurities from "./UnmappedSecurities";

const InsightsList = () => (
  <ListGroup>
    <UnassignedAccounts />
    <UnknownTaxClassification />
    <NewSecurities />
    <TradeProposalSummary />
    <RebalanceOpportunities />
    <UnassignedFeeStructuresModels />
    <UnassignedCashSettings />
    <UnmappedSecurities />
  </ListGroup>
);

export default InsightsList;
